import { connect } from 'react-redux';

import View3D from '../components/GraphView/3DView';

const mapStateToProps = (state, props) => {
  const params = props.url && new URLSearchParams(props.url);
  return {
    defaultActiveFilters: props.url
      ? JSON.parse(params.get('activeFilters'))
      : [
          {
            stattype: undefined,
            system: undefined,
            leadtime: undefined,
            area: undefined,
            source: undefined,
            stat: undefined,
            level: undefined,
          },
        ],
    defaultDisplay3D: { type: state.type['3d'][0].type },
    graphTypes: state.type['3d'],
    colorscale: state.style.scale,
    minMax: state.style.minMax,
  };
};

const ViewPage3D = connect(mapStateToProps)(View3D);

export default ViewPage3D;
